<template>
  <div class="conmon">
    <el-button
      type="primary"
      @click="openTencent()"
      icon="el-icon-plus"
      style="margin-bottom:10px;"
    >从云端同步</el-button>
    <div v-loading="webLoading">
      <el-table
        ref="multipleTables"
        :data="page.rows"
        tooltip-effect="dark"
        v-if="name=='录播'"
        style="width: 100%;"
        border
        @selection-change="selectionChangeLeft"
      >
        <el-table-column type="selection" width="40"></el-table-column>
        <el-table-column prop="sort" label="排序" width="55"></el-table-column>
        <el-table-column prop="videoCourseName" label="具体课程" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="name" label="视频名称" :show-overflow-tooltip="true"></el-table-column>

        <el-table-column prop="tryUse" label="试看" align="center" width="100">
          <template slot-scope="row">
            <span v-if="row.row.tryUse=='1' " class="mainColor">是</span>
            <span v-else class="mainColor">否</span>
          </template>
        </el-table-column>
        <el-table-column prop="playCount" label="次数" align="center" width="100"></el-table-column>
        <el-table-column align="center" prop="url" label="播放" width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            <i
              class="el-icon-caret-right"
              style="font-size:20px;color: #409EFF;"
              @click="inintVideo(scope.row)"
            ></i>
          </template>
        </el-table-column>
        <el-table-column prop="duration" align="center" width="100" label="时长"></el-table-column>
        <el-table-column prop label="操作" width="160" align="center">
          <template slot-scope="scope">
            <div class="operationGroup">
              <el-button type="text" size="small" @click="getVideoInfo(scope.row)">编辑</el-button>
              <el-button type="text" size="small" @click="deleteVideo(scope.row)">解绑</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      background
      layout="total, sizes, prev, pager, next"
      style="margin-top: 20px;text-align: right;"
      :total="page.total"
      :page-sizes="[10, 20, 30, 40]"
      :small="true"
      :page-size="page.pageSize"
      :current-page="page.pageNumber"
      @size-change="sizeChange"
      @current-change="currentChange"
    ></el-pagination>
    <div slot="footer" class="dialog-footer" style="text-align: right">
      <!-- <el-button type="primary" @click="addQuestionBatchVideo" icon="el-icon-document">保存</el-button> -->
    </div>
    <el-dialog
      title="预览视频"
      :visible.sync="videoDialog"
      @close="closeDialog"
      width="900px"
      :append-to-body="true"
      :close-on-click-modal="false"
    >
      <!-- <video-player
        class="video-player vjs-custom-skin"
        ref="videoPlayer"
        :playsinline="true"
        :options="playerOptions"
      ></video-player>-->
      <!-- <video
          id="player-container-id"
          class="video-style"
          preload="auto"
      ></video>-->
      <video
        v-if="videoShow"
        id="player-container-id"
        width="860"
        height="450"
        preload="auto"
        playsinline
        webkit-playsinline
      ></video>
    </el-dialog>
    <el-dialog
      :title="'添加'+name+'视频'"
      :append-to-body="true"
      :visible.sync="addFormVisible2"
      width="900px"
      :close-on-click-modal="false"
    >
      <el-form ref="addForm" :model="addForm2" :label-width="formLabelWidth" :rules="addFormRules">
        <el-row>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="视频名称" prop="name">
              <el-input
                v-model="addForm2.name"
                placeholder="请输入名称"
                auto-complete="off"
                maxlength="120"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="排序" prop="sort">
              <el-input
                type="number"
                v-model="addForm2.sort"
                placeholder="请输入排序"
                auto-complete="off"
                maxlength="10"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="总开始时间" prop="startTime">
              <el-date-picker
                style="width:100%"
                value-format="yyyy-MM-dd HH:mm:ss"
                v-model="addForm2.startTime"
                type="datetime"
                placeholder="选择日期时间"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="12">
            <!-- <el-form-item label="总结束时间" prop="endTime">
              <el-date-picker
                style="width:100%"
                value-format="yyyy-MM-dd HH:mm:ss"
                v-model="addForm2.endTime"
                type="datetime"
                placeholder="选择日期时间"
              ></el-date-picker>
            </el-form-item>-->
            <el-form-item label="预计时长" prop="value">
              <el-select
                :disabled="addForm2.startTime?false:true"
                style="width:100%"
                v-model="addForm2.value"
                placeholder="请选择"
              >
                <el-option v-for="item in 24" :key="item" :label="item+'小时'" :value="item"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="18" :md="12" :lg="12">
            <el-form-item label="试看" prop="tryUse">
              <!-- <el-input v-model="addForm2.type" placeholder="请输入类别：免费/付费/会员" auto-complete="off" maxlength="50"></el-input> -->
              <el-radio-group v-model="addForm2.tryUse" size="small">
                <el-radio label="1">是</el-radio>
                <el-radio label="-1">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="视频说明" prop="remark">
              <el-input
                type="textarea"
                v-model="addForm2.remark"
                placeholder="请输入视频说明"
                auto-complete="off"
                maxlength="300"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align:right">
        <el-button @click="addFormVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="addVideoInfo">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="'添加'+name+'视频'"
      :append-to-body="true"
      :visible.sync="addFormVisible"
      width="900px"
      :close-on-click-modal="false"
    >
      <el-form ref="addForm" :model="addForm" :label-width="formLabelWidth" :rules="addFormRules">
        <el-row>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="视频名称" prop="name">
              <el-input
                v-model="addForm.name"
                placeholder="请输入名称"
                auto-complete="off"
                maxlength="120"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="视频地址" prop="url">
              <el-input
                v-model="addForm.url"
                placeholder="请输入视频地址"
                auto-complete="off"
                maxlength="500"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="排序" prop="sort">
              <el-input
                type="number"
                v-model="addForm.sort"
                placeholder="请输入排序"
                auto-complete="off"
                maxlength="10"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="18" :md="12" :lg="12">
            <el-form-item label="试看" prop="tryUse">
              <!-- <el-input v-model="addForm.type" placeholder="请输入类别：免费/付费/会员" auto-complete="off" maxlength="50"></el-input> -->
              <el-radio-group v-model="addForm.tryUse" size="small">
                <el-radio label="1">是</el-radio>
                <el-radio label="-1">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="视频id" prop="tencentVideoId">
              <el-input
                v-model="addForm.tencentVideoId"
                placeholder="请输入腾讯视频id"
                auto-complete="off"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="腾讯appid" prop="tencentAppid">
              <el-input
                v-model="addForm.tencentAppid"
                placeholder="请输入腾讯appid"
                auto-complete="off"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="播放次数" prop="playCount">
              <el-input
                v-model="addForm.playCount"
                placeholder="请输入播放次数"
                auto-complete="off"
                maxlength="11"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="播放时长" prop="duration">
              <el-input
                v-model="addForm.duration"
                placeholder="请输入播放时长"
                auto-complete="off"
                maxlength="11"
              >
                <template slot="append">秒</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row></el-row>
        <el-row>
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="视频说明" prop="remark">
              <el-input
                type="textarea"
                v-model="addForm.remark"
                placeholder="请输入视频说明"
                auto-complete="off"
                maxlength="300"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align:right">
        <el-button @click="addFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addVideoInfo">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="编辑直播视频"
      :append-to-body="true"
      :visible.sync="editFormVisible2"
      width="900px"
      left
      :close-on-click-modal="false"
    >
      <el-form
        ref="editForm"
        :model="editForm2"
        :label-width="formLabelWidth"
        :rules="editFormRules"
      >
        <el-row>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="视频名称" prop="name">
              <el-input
                v-model="editForm2.name"
                placeholder="请输入名称"
                auto-complete="off"
                maxlength="120"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="排序" prop="sort">
              <el-input
                type="number"
                v-model="editForm2.sort"
                placeholder="请输入排序"
                auto-complete="off"
                maxlength="10"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="总开始时间" prop="startTime">
              <el-date-picker
                style="width:100%"
                value-format="yyyy-MM-dd HH:mm:ss"
                v-model="editForm2.startTime"
                type="datetime"
                placeholder="选择日期时间"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="12">
            <!-- <el-form-item label="总结束时间" prop="endTime">
              <el-date-picker
                style="width:100%"
                value-format="yyyy-MM-dd HH:mm:ss"
                v-model="editForm2.endTime"
                type="datetime"
                placeholder="选择日期时间"
              ></el-date-picker>
            </el-form-item>-->
            <el-form-item label="预计时长" prop="value">
              <el-select
                :disabled="editForm2.startTime?false:true"
                style="width:100%"
                v-model="editForm2.value"
                placeholder="请选择"
              >
                <el-option v-for="item in 24" :key="item" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="18" :md="12" :lg="12">
            <el-form-item label="试看" prop="tryUse">
              <!-- <el-input v-model="addForm.type" placeholder="请输入类别：免费/付费/会员" auto-complete="off" maxlength="50"></el-input> -->
              <el-radio-group v-model="editForm2.tryUse" size="small">
                <el-radio label="1">是</el-radio>
                <el-radio label="-1">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="视频说明" prop="remark">
              <el-input
                type="textarea"
                v-model="editForm2.remark"
                placeholder="请输入视频说明"
                auto-complete="off"
                maxlength="300"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
        style="text-align: right"
        :close-on-click-modal="false"
      >
        <el-button @click="editFormVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="updateVideoInfo">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="编辑录播视频"
      :append-to-body="true"
      :visible.sync="editFormVisible"
      width="900px"
      left
      :close-on-click-modal="false"
    >
      <el-form
        ref="editForm"
        :model="editForm"
        :label-width="formLabelWidth"
        :rules="editFormRules"
      >
        <el-row>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="视频名称" prop="name">
              <el-input
                v-model="editForm.name"
                placeholder="请输入名称"
                auto-complete="off"
                maxlength="120"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="视频地址" prop="url">
              <el-input
                v-model="editForm.url"
                placeholder="请输入视频地址"
                auto-complete="off"
                maxlength="500"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="排序" prop="sort">
              <el-input
                type="number"
                v-model="editForm.sort"
                placeholder="请输入排序"
                auto-complete="off"
                maxlength="10"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="18" :md="12" :lg="12">
            <el-form-item label="试看" prop="tryUse">
              <!-- <el-input v-model="addForm.type" placeholder="请输入类别：免费/付费/会员" auto-complete="off" maxlength="50"></el-input> -->
              <el-radio-group v-model="editForm.tryUse" size="small">
                <el-radio label="1">是</el-radio>
                <el-radio label="-1">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="视频id" prop="tencentVideoId">
              <el-input
                v-model="editForm.tencentVideoId"
                placeholder="请输入腾讯视频id"
                auto-complete="off"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="播放次数" prop="playCount">
              <el-input
                v-model="editForm.playCount"
                placeholder="请输入播放次数"
                auto-complete="off"
                maxlength="11"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!--        <el-row>-->
        <!--          <el-col :sm="24" :md="12" :lg="12">-->
        <!--                        <el-form-item label="腾讯appid" prop="tencentAppid">-->
        <!--                          <el-input-->
        <!--                            v-model="editForm.tencentAppid"-->
        <!--                            placeholder="请输入腾讯appid"-->
        <!--                            auto-complete="off"-->
        <!--                            maxlength="50"-->
        <!--                          ></el-input>-->
        <!--                        </el-form-item>-->
        <!--          </el-col>-->
        <!--          <el-col :sm="24" :md="12" :lg="12">-->
        <!--            <el-form-item label="播放时长" prop="duration">-->
        <!--              <el-input-->
        <!--                v-model="editForm.duration"-->
        <!--                placeholder="请输入播放时长"-->
        <!--                auto-complete="off"-->
        <!--                maxlength="11"-->
        <!--              >-->
        <!--                <template slot="append">秒</template>-->
        <!--              </el-input>-->
        <!--            </el-form-item>-->
        <!--          </el-col>-->
        <!--        </el-row>-->
        <el-row>
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="视频说明" prop="remark">
              <el-input
                type="textarea"
                v-model="addForm.remark"
                placeholder="请输入视频说明"
                auto-complete="off"
                maxlength="300"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
        style="text-align: right"
        :close-on-click-modal="false"
      >
        <el-button @click="editFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateVideoInfo">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="excel导入"
      :append-to-body="true"
      :visible.sync="addFormVisibleExcel"
      width="900px"
      :close-on-click-modal="false"
    >
      <div class="flex-view">
        <el-upload
          class="upload-demo"
          :action="fileAction"
          :on-success="handleSuccess"
          :headers="reqData"
          :show-file-list="false"
        >
          <el-button size="small" type="primary" icon="el-icon-upload">点击上传</el-button>
        </el-upload>
        <el-button
          style="margin-left:10px;"
          size="small"
          type="primary"
          @click="downloadFile()"
        >下载模板</el-button>
        <div style="margin-left:10px;" class="el-upload__tip">只能上传xls、xlsx文件，且不超过1024kb</div>
      </div>
      <el-table
        ref="multipleTables"
        :data="importForm"
        tooltip-effect="dark"
        style="width: 100%;"
        border
        @selection-change="selectionExcel"
      >
        <!-- <el-table-column type="selection" width="40"></el-table-column> -->
        <el-table-column show-overflow-tooltip prop="name" label="视频名称"></el-table-column>
        <el-table-column show-overflow-tooltip prop="tencentVideoId" label="视频id"></el-table-column>
        <el-table-column show-overflow-tooltip prop="url" label="视频地址"></el-table-column>

        <el-table-column show-overflow-tooltip prop="duration" label="视频时长"></el-table-column>
        <el-table-column show-overflow-tooltip prop="playCount" label="播放次数"></el-table-column>
        <el-table-column show-overflow-tooltip prop="tryUse" label="是否试看">
          <template slot-scope="row">
            <span v-if="row.row.tryUse=='1' " class="mainColor">是</span>
            <span v-else class="mainColor">否</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="tencentAppid" label="腾讯appid"></el-table-column>
        <el-table-column show-overflow-tooltip prop="remark" label="视频说明"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer" style="text-align:right">
        <el-button @click="addFormVisibleExcel = false">取 消</el-button>
        <el-button type="primary" @click="bindExcel()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="同步腾迅云"
      :append-to-body="true"
      :visible.sync="tencentSyncVisible"
      width="900px"
      :loading= "openTencentLoading"
      element-loading-text="拼命加载中"
      element-loading-background="rgba(255, 255, 255, 0.8)"
      :close-on-click-modal="false"
    >
      <div>
        <el-row :gutter="20">
          <el-col :span="4">
            <el-button
              size="small"
              type="primary"
              @click="syncTencent()"
              :loading="this.syncStatus"
            >同步腾迅云</el-button>
          </el-col>
          <el-col :span="20" style="text-align:right">
            <el-input
              style="width:200px"
              size="small"
              v-model="tencentPage.name"
              placeholder="请输入视频名称"
              clearable
            ></el-input>
            <el-input
              style="width:200px"
              size="small"
              v-model="tencentPage.remark"
              placeholder="请输入备注关键字"
              clearable
            ></el-input>
            <el-button
              size="small"
              type="primary"
              @click="tencentPage.pageNumber=1,openTencent()"
            >查询</el-button>
          </el-col>
        </el-row>
      </div>
      <el-table
        ref="multipleTables"
        :data="tencentPage.rows"
        @selection-change="selectionChangeTencent"
        tooltip-effect="dark"
        style="width: 100%;margin-top:10px"
        border
      >
        <el-table-column :show-overflow-tooltip="true" type="selection" width="55"></el-table-column>
        <el-table-column show-overflow-tooltip prop="name" label="视频名称"></el-table-column>
        <el-table-column show-overflow-tooltip prop="tencentVideoId" label="视频id"></el-table-column>
        <el-table-column show-overflow-tooltip prop="url" label="视频地址"></el-table-column>
        <el-table-column show-overflow-tooltip prop="duration" label="视频时长"></el-table-column>
        <el-table-column prop="createTime" label="上传时间"></el-table-column>
        <el-table-column prop="remark" label="备注"></el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total, sizes, prev, pager, next"
        style="margin-top: 20px;text-align: right;"
        :total="tencentPage.total"
        :page-sizes="[10, 20, 30, 40]"
        :small="true"
        :page-size="tencentPage.pageSize"
        :current-page="tencentPage.pageNumber"
        @size-change="sizeChangeTencent"
        @current-change="currentChangeTencent"
      ></el-pagination>
      <div slot="footer" class="dialog-footer" style="text-align:right">
        <el-button @click="tencentSyncVisible = false">取 消</el-button>
        <el-button type="primary" @click="bindTencent()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import $ from 'jquery';
export default {
  components: { draggable },
  props: {
    id: {
      type: String
    },
    name: {
      type: String
    }
  },
  created() {},
  data() {
    return {
      openTencentLoading: false,
      player: null,
      videoShow: false,
      loadVideoShow: false,
      syncStatus: false,
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "", //这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src: "" //url地址
          }
        ],
        poster: "../../static/images/test.jpg", //你的封面地址
        // width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true //全屏按钮
        }
      },
      formLabelWidth: "100px",
      createTime: [],
      fileAction: `${process.env.BASE_URL}/videoInfo/importVideoInfoExcel`,

      priceDisabled: true,
      addFormVisibleExcel: false,
      tencentSyncVisible: false,
      priceEditDisabled: true,
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      },
      tencentPage: {
        rows: [],
        total: 0,
        remark: "",
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      },
      webLoading: false,
      videoDialog: false,
      addFormVisible2: false,
      addFormVisible: false,
      editFormVisible: false,
      editFormVisible2: false,
      videoCourseIds: [],
      addVideoLeft: [],
      addTencentVideo: [],
      addVideoRight: [],
      videoCourseTree: [],
      subjectTreeList: [], //科目
      subjectTreeProps: {
        multiple: true,
        value: "id",
        label: "name",
        children: "children"
      },
      subjectTreePropsNo: {
        value: "id",
        label: "name",
        children: "children"
      },
      addForm: {
        videoCourseId: "",
        name: "",
        courseId: "",
        sort: "",
        tryUse: "-1",
        price: "",
        tencentVideoId: "",
        tencentAppid: "",
        enabled: "1",
        url: "",
        remark: "",
        playCount: "",
        duration: ""
      },
      addForm2: {
        name: "",
        sort: "",
        tryUse: "-1",
        remark: "",
        startTime: "",
        endTime: "",
        enabled: "1"
      },
      addFormRules: {
        videoCourseId: [
          {
            required: true,
            message: "请输入所属视频课程id",
            trigger: "blur"
          }
        ],
        value: [
          {
            required: true,
            message: "请输入",
            trigger: "blur"
          }
        ],
        startTime: [
          {
            required: true,
            message: "请输入",
            trigger: "blur"
          }
        ],
        endTime: [
          {
            required: true,
            message: "请输入",
            trigger: "blur"
          }
        ],
        name: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur"
          },
          {
            min: 1,
            max: 100,
            message: "名称长度在1到100个字"
          }
        ],
        sort: [
          {
            required: true,
            message: "请输入排序",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "排序格式不正确"
          }
        ],
        type: [
          {
            required: true,
            message: "请选择类别：免费/付费/会员",
            trigger: "change"
          }
        ],
        price: [
          {
            required: true,
            message: "请输入价格",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "价格格式不正确"
          }
        ],
        tencentVideoId: [
          {
            required: true,
            message: "请输入腾讯视频id",
            trigger: "blur"
          },
          {
            min: 1,
            max: 50,
            message: "腾讯视频id长度在1到50个字"
          }
        ],
        tencentAppid: [
          {
            required: true,
            message: "请输入腾讯appid",
            trigger: "blur"
          },
          {
            min: 1,
            max: 50,
            message: "腾讯appid长度在1到50个字"
          }
        ],
        enabled: [
          {
            required: true,
            message: "请输入开启 1开启",
            trigger: "change"
          }
        ],
        url: [
          {
            required: true,
            message: "请输入视频地址",
            trigger: "blur"
          },
          {
            min: 1,
            max: 500,
            message: "视频地址长度在1到500个字"
          }
        ],
        playCount: [
          {
            required: true,
            message: "请输入播放次数",
            trigger: "blur"
          }
        ],
        duration: [
          {
            required: true,
            message: "请输入播放时长",
            trigger: "blur"
          }
        ]
      },
      fileObj: {
        url: process.env.BASE_URL + "/system/uploadFile"
      },
      editForm2: {
        name: "",
        sort: "",
        tryUse: "-1",
        remark: "",
        startTime: "",
        endTime: "",
        enabled: "1"
      },
      editForm: {
        videoCourseId: "",
        courseId: "",
        name: "",
        sort: "",
        tryUse: "-1",

        price: "",
        tencentVideoId: "",
        tencentAppid: "",
        url: "",
        remark: "",
        enabled: ""
      },
      editFormRules: {
        value: [
          {
            required: true,
            message: "请输入",
            trigger: "blur"
          }
        ],
        videoCourseId: [
          {
            required: true,
            message: "请输入所属视频课程id",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "所属视频课程id格式不正确"
          }
        ],
        name: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur"
          },
          {
            min: 1,
            max: 100,
            message: "名称长度在1到100个字"
          }
        ],
        sort: [
          {
            required: true,
            message: "请输入排序",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "排序格式不正确"
          }
        ],
        type: [
          {
            required: true,
            message: "请输入类别：免费/付费/会员",
            trigger: "blur"
          }
        ],
        price: [
          {
            required: true,
            message: "请输入价格",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "价格格式不正确"
          }
        ],
        tencentVideoId: [
          {
            required: true,
            message: "请输入腾讯视频id",
            trigger: "blur"
          },
          {
            min: 1,
            max: 50,
            message: "腾讯视频id长度在1到50个字"
          }
        ],
        tencentAppid: [
          {
            required: true,
            message: "请输入腾讯appid",
            trigger: "blur"
          },
          {
            min: 1,
            max: 50,
            message: "腾讯appid长度在1到50个字"
          }
        ],
        url: [
          {
            required: true,
            message: "请输入视频地址",
            trigger: "blur"
          },
          {
            min: 1,
            max: 500,
            message: "视频地址长度在1到500个字"
          }
        ],
        enabled: [
          {
            required: true,
            message: "请输入开启 1开启",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "开启 1开启格式不正确"
          }
        ],
        playCount: [
          {
            required: true,
            message: "请输入播放次数",
            trigger: "blur"
          }
        ],
        duration: [
          {
            required: true,
            message: "请输入播放时长",
            trigger: "blur"
          }
        ]
      },
      searchForm: {},
      tencentForm: {
        remark: ""
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      importForm: []
    };
  },
  computed: {
    reqData() {
      return this.$store.state.user;
    }
  },
  methods: {
    selectVideo(item){
      if(this.loadVideoShow){
        console.log("loadVideoShow")
        this.changeVideo(item);
      }else{
        this.inintVideo(item);
      }
      // this.inintVideo(item)
    },
    inintVideo(item) {
      this.videoDialog = true;
      this.videoShow = true;
      this.loadVideoShow = true;
      // $('#id_test_video').html("");
      this.$nextTick(function() {
        this.player = TCPlayer("player-container-id", {
          // player-container-id 为播放器容器 ID，必须与 html 中一致
          fileID: item.tencentVideoId, // 请传入需要播放的视频 filID（必须）
          appID: item.tencentAppid, // 请传入点播账号的 appID（必须）
          autoplay: true
        });
      });
    },
    changeVideo(item) {
      this.videoDialog = true;
      this.videoShow = true;
      this.player.loadVideoByID({
        fileID: item.tencentVideoId, // 请传入需要播放的视频 filID（必须）
        appID: item.tencentAppid, // 请传入点播账号的 appID（必须）
        autoplay: true
      });
    },
    closeDialog() {
      // this.$refs.videoPlayer.player.pause(); //暂停
      // console.log("11111",$('#player-container-id').html())
      // $('#player-container-id').empty();
      // console.log("2222",$('#player-container-id').html())
      this.player.dispose()
      this.videoShow = false;
      // this.player = null;
    },
    bindExcel() {
      this.api.videoInfo
        .addVideoInfoBatchByExcel({
          videoInfoList: this.importForm,
          videoCourseId: this.id
        })
        .then(result => {
          if (result.success) {
            this.$message({
              type: "success",
              message: result.message
            });
            this.addFormVisibleExcel = false;
            this.pageListLeft();
            this.importForm = [];
          } else {
            this.$message({
              type: "error",
              message: result.message
            });
          }
        });
    },
    syncTencent() {
      this.syncStatus = true;
      this.api.videoInfo.syncTencent({}).then(result => {
        this.syncStatus = false;
        if (result.success) {
          this.$message({
            type: "success",
            message: result.message
          });
          this.openTencent();
        } else {
          this.$message({
            type: "error",
            message: result.message
          });
        }
      });
    },
    bindTencent() {
      if(this.addTencentVideo.length>0){
        let ids = "";
      let that = this;
      this.addTencentVideo.forEach((res, index) => {
        if (index === that.addTencentVideo.length - 1) {
          ids += res.id;
        } else {
          ids += res.id + ",";
        }
      });
      this.api.videoInfo
        .bindTencent({
          ids: ids,
          videoCourseId: this.id
        })
        .then(result => {
          if (result.success) {
            this.$message({
              type: "success",
              message: result.message
            });
            this.tencentSyncVisible = false;
            this.tencentForm = [];
            this.pageListLeft();
          } else {
            this.$message({
              type: "error",
              message: result.message
            });
          }
        });
      }else{
        this.$message.error("请选择需要添加的视频！")
      }
      
    },
    handleSuccess(response, file, fileList, $event) {
      this.importForm = response.data;
    },
    getVideoInfo(row) {
      this.api.videoInfo
        .getVideoInfo({ id: row.id })
        .then(result => {
          result.data.tryUse = String(result.data.tryUse);
          if (this.name == "直播") {
            var date1 = new Date(result.data.startTime);
            var date2 = new Date(result.data.endTime);
            result.data.value = Math.floor(
              (date2.getTime() - date1.getTime()) / 1000 / 60 / 60
            );
            this.editForm2 = result.data;
            console.log(this.editForm2.value);
            this.editFormVisible2 = true;
          } else {
            this.editForm = result.data;
            this.editFormVisible = true;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    downloadFile() {
      const url = "./static/file/批量导入视频模板 .xlsx";
      window.open(url);
    },
    addVideoInfo() {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          let obj = {};
          if (this.name == "直播") {
            obj = this.addForm2;
          } else {
            obj = this.addForm;
          }
          obj.videoCourseId = this.id;
          this.api.videoInfo
            .addVideoInfo(obj)
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.pageListLeft();
                if (this.name == "直播") {
                  this.addFormVisible2 = false;

                  this.addForm2 = {
                    name: "",
                    sort: "",
                    tryUse: "1",
                    remark: "",
                    enabled: "1"
                  };
                } else {
                  this.addFormVisible = false;
                  this.addForm = {
                    videoCourseId: "",
                    name: "",
                    courseId: "",
                    sort: "",
                    tryUse: "1",
                    price: "",
                    tencentVideoId: "",
                    tencentAppid: "",
                    enabled: "1",
                    url: "",
                    remark: "",
                    playCount: "",
                    duration: ""
                  };
                }
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    updateVideoInfo() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          let obj = {};
          if (this.name == "直播") {
            obj = this.editForm2;
          } else {
            obj = this.editForm;
          }
          this.api.videoInfo
            .updateVideoInfo(obj)
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                if (this.name == "直播") {
                  this.editFormVisible2 = false;
                } else {
                  this.editFormVisible = false;
                }
                this.pageListLeft();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    subjectChange() {
      this.addForm.courseId = this.addForm.courseId[2];
      this.api.videoCourse
        .getVideoCourseTree({ courseId: this.addForm.courseId })
        .then(result => {
          this.videoCourseTree = result.data;
        });
      this.addForm.courseId = "";
    },
    subjectEditChange() {
      this.editForm.courseId = this.editForm.courseId[2];
      this.api.videoCourse
        .getVideoCourseTree({ courseId: this.editForm.courseId })
        .then(result => {
          this.videoCourseTree = result.data;
        });
      this.editForm.courseId = "";
    },
    deleteAddVideoRight(item) {
      this.addVideoRight.forEach((res, index) => {
        if (item.id == res.id) {
          this.addVideoRight.splice(index, 1);
        }
      });
      this.$message.success("移除成功");
    },
    openDio() {
      if (this.name == "直播") {
        this.addFormVisible2 = true;
      } else {
        this.addFormVisible = true;
      }
    },
    openTencent() {
      this.openTencentLoading = true;
      this.tencentForm.pageSize = this.tencentPage.pageSize;
      this.tencentForm.pageNumber = this.tencentPage.pageNumber;
      this.tencentForm.sortName = this.tencentPage.sortName;
      this.tencentForm.sortOrder = this.tencentPage.sortOrder;
      this.tencentSyncVisible = true;
      let that = this;
      this.api.videoInfo
        .getTecent(this.tencentPage)
        .then(result => {
          this.webLoading = false;
          if (result.success) {
            this.openTencentLoading = false;
            // that.tencentForm = result.data
            that.tencentPage.rows = result.data.records;
            that.tencentPage.total = result.data.total;
          } else {
            this.$message.error(result.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    addVideoRightEvent() {
      this.addVideoLeft.forEach(item => {
        let sty = true;
        this.addVideoRight.forEach(items => {
          if (item.id == items.id) {
            sty = false;
          }
        });
        if (sty) {
          this.addVideoRight.push(item);
        }
      });
    },
    reset() {
      this.$refs.searchForm.resetFields();
      this.videoCourseIds = [];
      this.createTime = [];
      this.searchForm.createTimeBegin = "";
      this.searchForm.createTimeEnd = "";
      this.page = {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      };
      this.pageListLeft();
    },
    timeChange() {
      if (this.createTime) {
        this.searchForm.createTimeBegin = this.createTime[0];
        this.searchForm.createTimeEnd = this.createTime[1];
      } else {
        this.searchForm.createTimeBegin = "";
        this.searchForm.createTimeEnd = "";
      }
    },
    subjectSearchChange() {
      if (this.videoCourseIds.length > 0) {
        this.videoCourseIds.forEach(item => {
          this.searchForm.videoCourseIds.push(item[2]);
        });
      } else {
        this.searchForm.videoCourseIds = [];
      }
      console.log(this.searchForm.videoCourseIds);
    },
    //左侧list
    pageListLeft() {
      this.webLoading = true;
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.searchForm.videoCourseId = this.id;
      this.api.videoInfo
        .pageList(this.searchForm)
        .then(result => {
          this.webLoading = false;
          if (result.success) {
            for (let i in this.page.rows) {
              this.page.rows[i].enabled = String(this.page.rows[i].enabled);
            }
            this.page.rows = result.data.records;
            this.page.total = result.data.total;
          } else {
            this.$message.error(result.message);
          }
        })

        .catch(error => {
          console.log(error);
        });
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.pageListLeft();
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageListLeft();
    },
    currentChangeTencent(pageNumber) {
      this.tencentPage.pageNumber = pageNumber;
      this.openTencent();
    },
    sizeChangeTencent(pageSize) {
      this.tencentPage.pageSize = pageSize;
      this.openTencent();
    },
    //选择的video
    selectionChangeLeft(val) {
      this.addVideoLeft = val;
    },
    selectionChangeTencent(val) {
      this.addTencentVideo = val;
      console.dir(this.addTencentVideo);
    },
    selectionExcel(val) {
      this.addVideoExcel = val;
    },
    datadragEnd(evt) {
      // this.addExamRight.forEach((item, index) => {
      //   item.sort = index + 1;
      // });
      evt.preventDefault();
    },
    deleteVideo(row) {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.api.videoInfo
            .deleteVideoInfo([
              {
                id: row.id
              }
            ])
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.pageListLeft();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => {});
    },
    getSubjectTreeList() {
      // 获取课程
      this.api
        .getSubjectCourseTreeList()
        .then(result => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.children.length != 0) {
                  for (let itemss of items.children) {
                    delete itemss.children;
                  }
                } else {
                  // delete items.children;
                }
              }
            } else {
              // delete item.children;
            }
          }
          this.subjectTreeList = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    }
  },

  watch: {
    id() {
      this.pageListLeft();
    },
    "addForm2.value"() {
      var date = new Date(this.addForm2.startTime);
      date.setHours(date.getHours() + Number(this.addForm2.value));
      this.addForm2.endTime = this.format("yyyy-MM-dd hh:mm:ss", date);
    },
    "editForm2.value"() {
      var date = new Date(this.editForm2.startTime);
      date.setHours(date.getHours() + Number(this.editForm2.value));
      this.editForm2.endTime = this.format("yyyy-MM-dd hh:mm:ss", date);
    },
    "addForm2.startTime"() {
      let startTime = new Date(Date.parse(this.addForm2.startTime));
      let endTime = new Date(Date.parse(this.addForm2.endTime));
      //进行比较
      if (startTime > endTime) {
        this.addForm2.startTime = "";
        this.$message.error("开始时间不能大于结束时间");
      }
    },
    "addForm2.endTime"() {
      let startTime = new Date(Date.parse(this.addForm2.startTime));
      let endTime = new Date(Date.parse(this.addForm2.endTime));
      //进行比较
      if (startTime > endTime) {
        this.addForm2.endTime = "";
        this.$message.error("开始时间不能大于结束时间");
      }
    },
    "editForm2.startTime"() {
      let startTime = new Date(Date.parse(this.editForm2.startTime));
      let endTime = new Date(Date.parse(this.editForm2.endTime));
      //进行比较
      if (startTime > endTime) {
        this.editForm2.startTime = "";
        this.$message.error("开始时间不能大于结束时间");
      }
    },
    "editForm2.endTime"() {
      let startTime = new Date(Date.parse(this.editForm2.startTime));
      let endTime = new Date(Date.parse(this.editForm2.endTime));
      //进行比较
      if (startTime > endTime) {
        this.editForm2.endTime = "";
        this.$message.error("开始时间不能大于结束时间");
      }
    }
  },
  mounted() {
    this.getSubjectTreeList();
    this.pageListLeft();
  }
};
</script>
<style lang="less" scoped>
.video-style {
  height: 550px;
  width: 940px;
}
.flex-view {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 20px;
}

.draggable-tableaaa {
  border-top: 1px solid #d9ebf5;
  border-left: 1px solid #d9ebf5;
  height: 436px;
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;

  .bor {
    font-weight: bolder;
    color: #4e4e4e;
    background-color: rgb(250, 250, 250) !important;
  }

  .draggable-table {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    div {
      padding: 8px 10px;
      font-size: 12px;
      line-height: 23px;
    }

    .htmltittles {
      white-space: nowrap;
      padding: 0px;
      overflow: hidden;
      text-overflow: ellipsis;

      img {
        display: none !important;
      }

      p {
        font-size: 12px !important;
        line-height: 23px !important;
        margin: 0px !important;
        color: #606266 !important;
        white-space: nowrap !important;

        img {
          display: none !important;
        }
      }
    }

    .title {
      width: 60%;
      border-bottom: 1px solid #d9ebf5;
      border-right: 1px solid #d9ebf5;
      overflow: hidden;
      text-overflow: ellipsis;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;

      .state {
        padding: 0;

        span {
          padding: 4px 8px;
          color: #fff;
          border-radius: 4px;
          margin-right: 10px;
        }
      }

      .questionTypeName {
        padding: 0;

        span {
          padding: 4px 8px;
          color: #fff;
          border-radius: 4px;
          margin-right: 10px;
        }
      }

      white-space: nowrap;
    }

    .answer {
      width: 13.3%;
      border-bottom: 1px solid #d9ebf5;
      border-right: 1px solid #d9ebf5;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .delete {
      width: 13.3%;
      cursor: pointer;
      border-bottom: 1px solid #d9ebf5;
      text-align: center;
      border-right: 1px solid #d9ebf5;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}

.two-table {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 20px;
  height: 500px;
  width: 100%;

  .left-right {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;

    .left-right-item {
      width: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 30px;
      border-radius: 50%;
      border-width: 1px;
      border-style: solid;
      border-color: rgba(238, 238, 238, 1);
      font-size: 14px;
      color: #a2aabc;
      margin: 10px;
      cursor: pointer;
    }

    .left-right-item-select {
      width: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 30px;
      border-radius: 50%;
      background: rgb(64, 158, 255);
      border-width: 1px;
      border-style: solid;
      border-color: rgb(64, 158, 255);
      font-size: 14px;
      color: #ffffff;
      margin: 10px;
      cursor: pointer;
    }
  }
}

p {
  font-size: 14px;
}

.view-content {
  .view-video {
    width: 100%;
    display: flex;
    min-height: 50px;
    flex-direction: row;

    span {
      display: block;
      font-size: 14px;
      line-height: 30px;
    }
  }

  .view-one {
    width: 100%;
    display: flex;
    min-height: 50px;
    flex-direction: row;

    .optint-list {
      display: flex;
      flex-direction: column;
    }

    p {
      display: inline;
    }

    span {
      display: block;
      font-size: 14px;
      line-height: 30px;
    }
  }

  .view-two {
    height: 50px;
    display: flex;
    flex-direction: row;

    p {
      display: inline;
    }

    div {
      width: 50%;
      display: flex;
      flex-direction: row;
      align-items: center;

      span {
        display: block;
        font-size: 14px;
        line-height: 30px;
      }
    }
  }
}

.message {
  display: flex;
  flex-direction: row;

  .state {
    span {
      padding: 4px 8px;
      color: #fff;
      border-radius: 4px;
      margin-right: 10px;
    }
  }

  .questionTypeName {
    span {
      padding: 4px 8px;
      color: #fff;
      border-radius: 4px;
      margin-right: 10px;
    }
  }

  .htmltittle {
    white-space: nowrap;
    height: 23px;
    overflow: hidden;
    text-overflow: ellipsis;

    img {
      display: none !important;
    }

    p {
      font-size: 12px !important;
      font-size: 12px !important;
      margin: 0px !important;
      color: #606266 !important;
      white-space: nowrap !important;

      img {
        display: none !important;
      }
    }
  }
}

.top {
  width: 100%;
  display: flex;
  background: #fff;

  .top-item {
    width: 33.3%;
    margin-left: 10px;

    .item-lable {
      line-height: 30px;
      white-space: nowrap;
      font-size: 12px;
      color: rgb(162, 170, 188);
    }

    .item-value {
      white-space: nowrap;
      font-size: 18px;
      color: rgb(69, 90, 100);
      line-height: 30px;
    }
  }
}

.view-video {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  .view-item {
    display: flex;
    flex-direction: row;
    align-items: center;

    span {
    }
  }
}
</style>
<style lang="less" rel="stylesheet/less">
.vjs-big-play-button {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/videoCourse/conmon.vue